// extracted by mini-css-extract-plugin
export default {"startMenuTilesCont":"start-menu-cont-tiles_startMenuTilesCont__uqHSJ"};